import { render } from "./CreateGroupModal.vue?vue&type=template&id=671d698e&scoped=true"
import script from "./CreateGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupModal.vue?vue&type=script&lang=js"

import "./CreateGroupModal.vue?vue&type=style&index=0&id=671d698e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671d698e"]])

export default __exports__